import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './editInternalNoteDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useAuth } from '@/modules/context/AuthContext'
import TextArea from '@/components/_custom/TextArea/textArea'
import { useMutation } from '@apollo/client'
import { SET_INTERNAL_NOTE_SUGGEST } from '@/modules/API/suggest/suggestHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface EditInternalNoteDialogProps {
    open: boolean
    closeDialog: () => void
    internalNote: string
    userId: number
    refetchAllSuggest: () => void
}

const EditInternalNoteDialog: FunctionComponent<EditInternalNoteDialogProps> = ({
    open,
    closeDialog,
    internalNote,
    userId,
    refetchAllSuggest
}) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [newInternalNote, setNewInternalNote] = useState<string>(internalNote)

    function resetComment(): void {
        setNewInternalNote('')
        internalNoteSuggest({
            variables: {
                userId: userId,
                daycareId: user?.currentDaycare?.id,
                internalNote: ''
            }
        })
    }

    const [internalNoteSuggest] = useMutation(SET_INTERNAL_NOTE_SUGGEST, {
        variables: {
            userId: userId,
            daycareId: user?.currentDaycare?.id,
            internalNote: newInternalNote
        },
        onCompleted: () => {
            refetchAllSuggest()

            closeDialog()

            showNotificationSuccess(t('internalNoteUpdated'))
        },
        onError: () => {
            showNotificationError(t('internalNoteUpdatedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={closeDialog} className={styles.DialogAdd}>
            <DialogHeader title={t('internalNote')}></DialogHeader>
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextAreaInput}>
                    <TextArea
                        placeholder={t('internalNote')}
                        maxCount={250}
                        className={styles.TextArea}
                        value={newInternalNote}
                        onChange={setNewInternalNote}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'cancel'} onClick={closeDialog} className={styles.Button} />
                    {newInternalNote !== '' && internalNote === newInternalNote ? (
                        <ButtonTextIcon
                            type={'delete'}
                            onClick={resetComment}
                            disabled={internalNote !== newInternalNote}
                            className={styles.Button}
                        />
                    ) : (
                        <ButtonTextIcon
                            type={'confirm'}
                            onClick={internalNoteSuggest}
                            disabled={internalNote === newInternalNote}
                            className={styles.Button}
                        />
                    )}
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default EditInternalNoteDialog
